<template>
    <div class="app app-container-soluquim" ref="mainContainerRef"
        :class="{ 'inicio-gradient': $route.path === '/inicio' }">
        <AppHeader fixed v-if="!fullscreenActive">
            <button class="custom-sidebar-toggle" @click="toggleSidebarSmooth">
                <img v-if="!isSidebarMinimized" src="/img/brand/hide_sidebar.png" alt="Ocultar Sidebar" class="toggle-icon">
                <img v-else src="/img/brand/show_sidebar.png" alt="Mostrar Sidebar" class="toggle-icon">
            </button>
            <b-link class="navbar-brand custom-navbar-brand ps-0" to="/inicio">
                <img class="navbar-brand-full" src="img/brand/logo-soluquim-color.webp" width="126" height="31"
                    alt="Soluquim" />
                <img class="navbar-brand-minimized mb-1" src="img/brand/icono-solo.png" width="150" height="50"
                    alt="Soluquim" />
            </b-link>
            <b-navbar-nav class="d-md-down ml-auto">

                <el-select v-if="validarRol('contratista')" v-model="value" placeholder="Seleccionar empresa"
                    size="small">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
                <b-nav-item class="d-md-down">
                    <DefaultHeaderDropdown />
                </b-nav-item>

                <b-nav-item class="d-md-down mr-2">
                    <div class="company-content-navbar">
                        <b-button @click="() => onHandleGoToMyCompany()" tabindex="0" variant="light">
                            <b-img :src="selectedImagenCurrentCompany.imagen" fluid alt="Logo empresa"></b-img>
                        </b-button>
                    </div>
                </b-nav-item>

                <b-dropdown
                    right
                    no-caret
                    variant="link"
                    toggle-class="d-flex align-items-center"
                    menu-class="dropdown-menu-espaciado"
                >
                    <template #button-content>
                        <div class="user-content-navbar custom-dropdown-font-size">
                            <b-button href="#" tabindex="0" variant="light"  @click="() => {(isVisibleTranslateContent = false)}">

                                <b-avatar
                                    size="2rem"
                                    :badge="notifications.length > 0 ? `${notifications.length}` : null"
                                    variant="primary"
                                    badge-variant="danger"
                                    badge-top
                                    badge-right
                                >
                                    {{ getUser.username }}
                                </b-avatar>
                            </b-button>
                        </div>
                    </template>

                    <div class="p-2">
                        <b-dropdown-text class="custom-dropdown-font-size">
                            <div class="custom-class-user-content-navbar-content d-flex justify-content-start align-items-center">
                                <div class="custom-class-user-content-navbar--header-img">
                                    <b-avatar size="2rem" variant="primary">{{ getUser.username }}</b-avatar>
                                </div>
                                <div class="ml-3">
                                    <h5 class="mb-0 text-dark font-weight-bold">{{ getUser.names }} {{ getUser.surnames }}
                                    </h5>
                                    <p class="text-muted m-0">{{ getUser.email }}</p>
                                </div>
                            </div>
                            <h5 class="ml-roles text-normal" v-for="role of getUser.roles" :key="role"><b-badge variant="primary">{{ role }}</b-badge></h5>
                        </b-dropdown-text>

                        <div class="custom-class-user-content-navbar-separator"></div>

                        <!-- Perfil -->
                        <b-dropdown-item href="#" class="custom-dropdown-item custom-dropdown-font-size"
                            to="/perfil-usuario">
                            <div class="d-flex align-items-center">
                                <i class="fa fa-user text-primary"></i>
                                <span class="text-dark ml-3">Perfil de usuario</span>
                            </div>
                        </b-dropdown-item>
                        <!-- Notificaciones -->
                        <b-dropdown-item href="#" class="custom-dropdown-item custom-dropdown-font-size"
                            @click="notify = true">
                            <div class="d-flex align-items-center justify-content-between">
                                <div class="d-flex align-items-center">
                                    <i class="fa fa-bell text-primary"></i>
                                    <span class="text-dark ml-3">Notificaciones <b-badge variant="danger">{{
                                        notifications.length }}</b-badge></span>
                                </div>
                            </div>
                        </b-dropdown-item>

                        <!-- Traducir sistema -->
                        <div class="custom-dropdown-font-size language-container">
                            <div
                                class="language-item custom-dropdown-item"
                                :class="isVisibleTranslateContent ? null : 'collapsed'"
                                :aria-expanded="isVisibleTranslateContent ? 'true' : 'false'"
                                aria-controls="collapse-available-translate"
                                @click="isVisibleTranslateContent = !isVisibleTranslateContent"
                            >
                                <div class="d-flex align-items-center">
                                    <i class="fa fa-language text-primary"></i>
                                    <span class="text-dark ml-2">Traducir sistema</span>
                                </div>
                                <div class="language-item-item">
                                    <i :class="isVisibleTranslateContent ? 'fa fa-chevron-up' : 'fa fa-chevron-down'" />
                                </div>
                            </div>

                            <b-collapse id="collapse-available-translate" v-model="isVisibleTranslateContent" class="mt-2 p-0 m-0">
                                <b-card no-body class="shadow-sm border-none border-0">
                                    <TranslateModal ref="translateModalRef" />
                                </b-card>
                            </b-collapse>
                        </div>

                        <!-- Administración -->
                        <b-dropdown-item href="#" class="custom-dropdown-item custom-dropdown-font-size">
                            <div
                                v-if="validarRol('superadmin')"
                                class="custom-dropdown-item"
                                @click="() => onHandleGoToSettings()"
                            >
                                <div class="d-flex align-items-center">
                                    <i class="fa fa-cogs text-primary"></i>
                                    <span class="text-dark ml-3">Administración</span>
                                </div>
                            </div>
                        </b-dropdown-item>

                        <div class="custom-class-user-content-navbar-separator"></div>

                        <!-- Cerrar sesión -->
                        <b-dropdown-item href="#" @click="onHandleLogout"
                            class="custom-dropdown-item custom-dropdown-font-size">
                            <div class="d-flex align-items-center">
                                <i class="fa fa-sign-out text-danger"></i>
                                <span class="text-danger ml-3">Cerrar sesión</span>
                            </div>
                        </b-dropdown-item>
                    </div>
                </b-dropdown>

            </b-navbar-nav>
        </AppHeader>

        <!-- Modal detalles notificaciones -->
        <b-modal v-model="notify" ok-only class="float-left" scrollable title="Notificaciones" @hidden="onCloseModal">
            <p class="my-4" v-for="notification in notifications" :key="notification.id">
                <b-card :title="notification.data['title']">
                    <b-card-text>
                         <div v-if="isHtmlResponse(notification.data['description'])" v-html="notification.data['description']"></div>
                         <div v-else style="white-space: pre-line;">{{ notification.data['description'] }}</div>
                    </b-card-text>
                    <template #footer>
                        <small class="text-muted">Fecha: {{ notification.created_at }}</small> -
                        <b-button v-if="notification.data['btn']" small @click="accionNotify(notification)"
                            variant="primary">{{
                                notification.data['btn'] }}</b-button>
                    </template>
                </b-card>
            </p>
            <template v-if="notifications.length <= 0">
                <p>No tiene notificaciones.</p>
            </template>
        </b-modal>

        <div class="app-body">
            <div v-show="loading">
                <Loader></Loader>
            </div>
            <!-- Overlay para móvil -->
            <div class="sidebar-overlay" :class="{ 'show': !isSidebarMinimized }" @click="toggleSidebarSmooth"></div>
            <!-- Sidebar -->
            <div class="custom-sidebar" :class="{
                'minimized': isSidebarMinimized,
                'show-mobile': !isSidebarMinimized
            }">

                <!-- Navegación del menú -->
                <div class="sidebar-nav">
                    <!-- Buscador -->
                    <div class="sidebar-search">
                        <div class="search-container">
                                <input
                                v-model="filterSearch"
                                @keyup="onHandleSearch"
                                placeholder="Buscar módulos o sub módulos..."
                                type="text"
                                class="search-input"
                                autocomplete="off" />
                            <i class="fa fa-search search-icon"></i>
                            <i v-if="filterSearch" @click="onHandleCancelSearch" class="fa fa-close search-clear"></i>
                        </div>
                        <!-- Resultados de búsqueda [ítems del menú] -->
                        <div v-if="navItems.length <= 0 && !overlayMenu && !isSidebarMinimized" class="p-2 mt-4 text-center">

                            <i class="fa fa-search mr-2 text-dark"></i>
                            <small class="d-block text-dark">No se encontrar resultados.</small>
                            <b-button class="mt-1 text-dark px-3" pill variant="outline-info" size="sm"
                                @click="onHandleCancelSearch">
                                <i class="fa fa-refresh mr-1 text-dark"></i>
                                Actualizar menú
                            </b-button>

                            <b-alert show variant="warning" class="mt-4">
                                <small>
                                    <i class="fa fa-info-circle mr-1 text-dark"></i>
                                    Debes ingresar el nombre del módulo o sub módulo que deseas consultar.
                                </small>
                            </b-alert>

                            <!-- Ejemplo de ítems -->
                            <b-list-group class="p-0 mt-4">
                                <div class="mb-1 p-2 bg-info d-flex align-items-center">
                                    <i class="fa fa-list mr-2"></i>
                                    <small>Sugerencias de búsqueda</small>
                                </div>
                                <b-list-group-item v-for="(item, index) in getMenuExample" :key="index"
                                    class="p-2 d-flex justify-content-start gap-2"
                                    @click="onHandleSearchWithSuggested(item.name)" button>
                                    <i class="nav-icon mr-2 text-dark" style="width: 20px;" :class="item.icon"></i>
                                    <small class="text-dark">{{ item.name }}</small>
                                </b-list-group-item>
                            </b-list-group>

                        </div>
                    </div>

                    <!-- Menú -->
                    <nav class="nav-menu">
                        <div v-for="item in navItems" :key="item.name" class="nav-item">
                            <div v-if="item.children && item.children.length > 0" class="nav-dropdown">
                                <div 
                                    class="nav-link nav-dropdown-toggle" 
                                    :class="{ 'filtered': filterSearch && filterSearch.length > 0 }"
                                    :title="isSidebarMinimized ? item.name : ''"
                                    @click="toggleDropdown(item.name)"
                                >
                                    <i :class="item.icon" class="nav-icon"></i>
                                    <span class="nav-text">{{ item.name }}</span>
                                    <span class="nav-arrow">
                                        <span v-if="!expandedDropdowns.includes(item.name)">&lt;</span>
                                        <span v-else>v</span>
                                    </span>
                                </div>
                                <!-- Subsecciones -->
                                <div 
                                    v-if="expandedDropdowns.includes(item.name)" 
                                    class="nav-dropdown-menu"
                                >
                                    <router-link 
                                        v-for="child in item.children" 
                                        :key="child.name"
                                        :to="child.url" 
                                        class="nav-link nav-dropdown-item"
                                        :class="{ 'filtered': filterSearch && filterSearch.length > 0 }"
                                        :title="isSidebarMinimized ? child.name : ''"
                                    >
                                        <i :class="child.icon" class="nav-icon"></i>
                                        <span class="nav-text">{{ child.name }}</span>
                                    </router-link>
                                </div>
                            </div>
                            <!-- Item simple con URL -->
                            <router-link 
                                v-else-if="item.url" 
                                :to="item.url" 
                                class="nav-link" 
                                :class="{ 'filtered': filterSearch && filterSearch.length > 0 }"
                                :title="isSidebarMinimized ? item.name : ''"
                            >
                                <i :class="item.icon" class="nav-icon"></i>
                                <span class="nav-text">{{ item.name }}</span>
                            </router-link>
                            <!-- Item sin URL (grupo) -->
                            <div 
                                v-else 
                                class="nav-link nav-group" 
                                :class="{ 'filtered': filterSearch && filterSearch.length > 0 }"
                                :title="isSidebarMinimized ? item.name : ''"
                            >
                                <i :class="item.icon" class="nav-icon"></i>
                                <span class="nav-text">{{ item.name }}</span>
                            </div>
                        </div>
                    </nav>
                </div>

                <!-- Botón de actualizar menú cuando hay búsqueda activa -->
                <div class="p-2 d-flex justify-content-center button-menu-update"
                    v-if="(filterSearch && filterSearch.length > 0) && navItems.length > 0 && !isSidebarMinimized">
                    <div class="text-center mb-4">
                        <small class="d-block text-dark">Restablecer ítems del menú.</small>
                        <b-button class="mt-1 text-dark px-3" pill variant="info" size="sm"
                            @click="onHandleCancelSearch">
                            <i class="fa fa-refresh mr-1 text-dark"></i>
                            ACTUALIZAR MENÚ
                        </b-button>
                    </div>
                </div>

                <!-- version del sistema -->
                 <h6 v-if="version && !isSidebarMinimized" class="text-version text-right sidebar-version-placeholder">v.{{ version }}</h6>

            </div>
            <main class="main" ref="mainContainerRef">
                <modal-banner />
                <div style="-webkit-background-size: cover; -moz-background-size: cover; -o-background-size: cover; background-size: cover;"
                    class="container-fluid main-content" :class="{
                        'main-content-cp': $route.path === '/panel-de-control',
                        'inicio-gradient-2': $route.path === '/inicio'
                    }">
                    <MaintenanceBanner/>
                    <router-view />
                </div>
            </main>
            <AppAside fixed>
                <DefaultAside />
            </AppAside>
        </div>
        <TheFooter>
            <!--footer-->
            <div class="ml-auto">
                <span class="mr-1">Desarrollado por</span>
                <a href="https://web.mejoraysoluciones.com/">Mejora & Soluciones </a>
            </div>
        </TheFooter>

    </div>
</template>

<script>
import nav from '@/_nav';
import { mapState, mapActions, mapMutations } from 'vuex';
import {
    Header as AppHeader,
    Sidebar as AppSidebar,
    SidebarFooter,
    SidebarForm,
    SidebarHeader,
    SidebarNav,
    Aside as AppAside,
    Footer as TheFooter,
    Breadcrumb,
} from '@coreui/vue';
import DefaultAside from './DefaultAside';
import DefaultHeaderDropdown from './DefaultHeaderDropdown';
import { getAcls, validarPermisoComponente, getUuidToUser } from '../plugins/acl';
import Loader from './loader';
import modalBanner from '../views/banners/modal_banner';
import Pusher from 'pusher-js';
import TranslateModal from "./TranslateModal";
import moment from "moment";
import store from '../store/store';
import MaintenanceBanner from "./MaintenanceBanner.vue";

export default {
    name: 'DefaultContainer',
    components: {
        MaintenanceBanner,
        AppHeader,
        AppSidebar,
        AppAside,
        TheFooter,
        Breadcrumb,
        DefaultAside,
        DefaultHeaderDropdown,
        SidebarForm,
        SidebarFooter,
        SidebarHeader,
        SidebarNav,
        Loader,
        modalBanner,
        TranslateModal
    },
    created() {
        const sidebarState = localStorage.getItem('sidebarMinimized');
        if (sidebarState === 'true') {
            document.body.classList.add('sidebar-minimized');
        }
    },
    data() {
        return {
            acls: '',
            navItems: [],
            navItemsTemporary: [],
            refresh: false,
            destroyed: false,
            notify: false,
            version: '',

            inactiveTime: 0,
            activityTimer: null,
            activityTimeout: process.env.VUE_APP_TIME_INACTIVE,
            sendInfo: false,
            from: moment().format('YYYY-MM-DD HH:mm:ss'),
            to: null,
            statusList: [200, 201],

            isSidebarMinimized: localStorage.getItem('sidebarMinimized') === 'true',
            sidebarObserver: null,
            overlayMenu: false,
            filterSearch: null,
            expandedDropdowns: [],
            temporaryImagenCompany: "img/brand/logo_soluquim.png",
            isVisibleTranslateContent: false,
            validatePermissionComponent:  validarPermisoComponente,
            dropdownVisibleUserMenu: false
        };
    },
    async mounted() {
        this.setSendUserActiveInSystem(false);
        this.observeSidebarClass();
        this.addRefEventToItemMenu();

        this.suscripcionPusher();
        this.validarPermisoNotificaciones();
        this.version = localStorage.getItem('version');

        window.addEventListener("mousemove",()=>{
            /*  console.log('mousemove'); */
            this.resetTimer();
            this.onReactivateUserActiveInSystem();
        });
        window.addEventListener("keypress", ()=>{
            /*  console.log('keypress'); */
            this.resetTimer();
            this.onReactivateUserActiveInSystem();
        });
        window.addEventListener("click", ()=>{
            /*   console.log('click'); */
            this.resetTimer();
            this.onReactivateUserActiveInSystem();
        });
        window.addEventListener("scroll", ()=>{
            /* console.log('scroll'); */
            this.resetTimer();
            this.onReactivateUserActiveInSystem();
        });

        // Listener para cambios de tamaño de ventana (móvil/desktop)
        window.addEventListener("resize", () => {
            if (this.isMobileDevice() && !this.isSidebarMinimized) {
                this.toggleSidebarSmooth();
            }
        });

        this.startTimer();

        // Delegación de eventos para cerrar sidebar en móvil al hacer clic en items y sub-items
        const sidebarEl = document.querySelector('.custom-sidebar');
        if (sidebarEl) {
            this._sidebarClickDelegatedHandler = (evt) => {
                const clickedLink = evt.target && (evt.target.closest('.nav-dropdown-item') || evt.target.closest('.nav-link'));
                if (!clickedLink) return;
                if (clickedLink.classList && clickedLink.classList.contains('nav-dropdown-toggle')) return;
                if (this.isMobileDevice() && this.isSidebarMinimized === false) {
                    this.toggleSidebarSmooth();
                }
            };
            sidebarEl.addEventListener('click', this._sidebarClickDelegatedHandler, true);
        }

        /**
         * Si se recarga la página y se ha establecido la bandera 'show-spinner' en localStorage,
         * se activa el loader/spinner global.
         */
        if (localStorage.getItem('show-spinner')) {
            this.$nextTick(() => {
                if (this.$store) {
                    this.$store.commit('dashboard/load', true, { root: true });
                } else if (typeof store !== 'undefined') {
                    store.commit('dashboard/load', true, { root: true });
                }
                localStorage.removeItem('show-spinner');
            });
        }
        await this.getImagen({
            companyId: localStorage.getItem('my_company'),
            module: 'COMPANY'
        });
        this.showLicenceAlert();
    },

    beforeMount() {
        this.menu();
        this.navItemsTemporary = this.validMenuWithPermissions();

        if (!['http://localhost:8080', 'http://127.0.0.1:8080', 'http://soluquim.test:8080'].includes(document.location.origin)) {

            this._beforeUnloadHandler = (e) => {
                if (!localStorage.getItem('updating-version')) {
                    e.preventDefault();
                    e.returnValue = '';
                }
            };

            window.addEventListener('beforeunload', this._beforeUnloadHandler);

            window.addEventListener('unload', async () => {

                if (!localStorage.getItem('updating-version') && localStorage.getItem('token')) {

                    if (!this.to) {
                        this.to = moment().format('YYYY-MM-DD HH:mm:ss');
                    }

                    // Siempre enviar petición si hay token - forzar envío
                    try {
                        await this.saveTimeActiveFromUserAuth({
                            from: this.from,
                            to: this.to,
                            reactive: false,
                            user_id: this.acls.usuario_id || null,
                            uuid: getUuidToUser() || null
                        });
                    } catch (error) {
                        console.log('Error al enviar tiempo de sesión:', error);
                    }

                    localStorage.clear();
                }
            });
            if (localStorage.getItem('updating-version')) {
                localStorage.removeItem('updating-version');
            }
        }
    },

    methods: {
        ...mapActions('autenticacion', ['logout', 'saveTimeActiveFromUserAuth', 'showLicenceAlert']),
        ...mapActions('dashboard', ['notificationMarkAsRead', 'notificationsUnread', 'notificationMarkManyAsReadSilent']),

        async onCloseModal() {
            if (this.notifications.length > 0) {
                const ids = this.notifications.map(n => n.id);
                // Frontend Only: Vaciar local storage y actualizar estado (Inmediato)
                localStorage.setItem('notifylocalStorage', JSON.stringify([]));
                this.setNotificationsUnread();

                // Backend Sync: Marcar como leídas silenciamente (Para que no reaparezcan)
                await this.notificationMarkManyAsReadSilent(ids);
            }
        },
        ...mapMutations('dashboard', ['setTabActive', 'setNotificationsUnread']),
        ...mapActions('empresa', ['getImagen', 'getUsuario']),
        ...mapMutations('auth', ['setSendUserActiveInSystem']),
        observeSidebarClass() {
            this.sidebarObserver = new MutationObserver(() => {
                const currentState = document.body.classList.contains('sidebar-minimized');
                this.isSidebarMinimized = currentState;
                if (currentState && this.filterSearch && this.filterSearch !== '') {
                    this.onHandleCancelSearch();
                }
            });
            this.sidebarObserver.observe(document.body, {
                attributes: true,
                attributeFilter: ['class']
            });
        },

        toggleSidebarSmooth() {
            const body = document.body;

            const isMinimized = body.classList.contains('sidebar-minimized');

            if (isMinimized) {
                body.classList.remove('sidebar-minimized');
                this.isSidebarMinimized = false;
                localStorage.setItem('sidebarMinimized', 'false');
            } else {
                body.classList.add('sidebar-minimized');
                this.isSidebarMinimized = true;
                localStorage.setItem('sidebarMinimized', 'true');
            }
        },

        isMobileDevice() {
            return window.innerWidth <= 991.98;
        },

        toggleDropdown(itemName) {
            const index = this.expandedDropdowns.indexOf(itemName);
            if (index > -1) {
                this.expandedDropdowns.splice(index, 1);
            } else {
                this.expandedDropdowns.push(itemName);
            }
        },

        handleInputFilterSearch() {
            if (this.$refs.mainContainerRef) this.$refs.mainContainerRef.classList.add('sidebar-show');
            this.filterMenu(this.filterSearch, 200)
        },

        onHandleGoToMyCompany() {
            const companyId = localStorage.getItem('my_company')
            if (!companyId) return

            this.$router.push(`/my-company/${companyId}`)
        },

        onHandleGoToSettings() {
            this.dropdownVisibleUserMenu = false

            if (this.$router.history.current.path == "/administracion") return
            this.$router.push(`/administracion`)
        },

        menu() {
            this.navItems = this.validMenuWithPermissions();
            this.overlayMenu = false
        },

        validarPermiso(item) {
            let visible = false;

            if (item.permisos.length) {
                visible = !!this.acls.permisos.filter(permiso => item.permisos.includes(permiso)).length;

                if (!visible) {
                    visible = !!this.acls.roles.filter(permiso => item.permisos.includes(permiso)).length;
                }
            }

            return visible;
        },
        async onHandleLogout() {
            await this._logout();
        },
        async _logout() {
            if (this.destroyed === false) {
                this.refresh = true;

                if (!this.to) {
                    this.to = moment().format('YYYY-MM-DD HH:mm:ss');
                }

                // Siempre enviar petición si hay token - el backend manejará si crear o cerrar sesión
                if(!this.sendUserActiveInSystem) {
                    await this.saveTimeActiveFromUserAuth({
                        from: this.from,
                        to: this.to,
                        reactive: false,
                        user_id: this.acls.usuario_id || null,
                        uuid: getUuidToUser() || null
                    }).catch(() => { })
                }

                await this.logout();
                if (this._beforeUnloadHandler) {
                    window.removeEventListener('beforeunload', this._beforeUnloadHandler);
                }
                await this.$router.push('/login');
                this.destroyed = false;
            }
        },
        validarRol(rolABuscar) {
            return !!this.acls.roles.find((role) => role === rolABuscar);
        },
        suscripcionPusher() {
            const acls = getAcls();

            if (!acls || !acls.uuid) {
                return;
            }

            let nombre_canal = acls.uuid;

            Pusher.logToConsole = false;

            let pusher = new Pusher('5c41c1dc4bec329b2165', {
                cluster: 'us2'
            });

            let canal = pusher.subscribe(nombre_canal);
            canal.bind('notificaciones', async (data) => {

                if (Notification.permission !== 'granted') {
                    Notification.requestPermission();
                } else {
                    let notification = new Notification(data.mensaje.titulo,
                        {
                            icon: 'favicon.ico',
                            body: this.stripHtml(data.mensaje.texto),
                            requireInteraction: true
                        }
                    );

                    if (data.mensaje.url) {
                        notification.onclick = (event) => {
                            event.preventDefault();
                            window.open(process.env.VUE_APP_API_URL + data.mensaje.url, '_blank');
                        };
                    }

                    if (data.mensaje.visibleNotification) {
                        setTimeout(async () => {
                            await this.notificationsUnread()
                        }, 3000);

                    }

                    setTimeout(() => {
                        notification.close();
                    }, 10000);

                    this.$notify({
                        title: data.mensaje.titulo,
                        message: this.stripHtml(data.mensaje.texto),
                        type: data.mensaje.error ? 'error' : 'success',
                        url: data.mensaje.url,
                        duration: 8000
                    });

                    // Emitir evento global para que componentes específicos recarguen datos
                    this.$root.$emit('notificacion-inventario', data);
                }
            });
        },
        isHtmlResponse(text) {
            return String(text).includes('<') && String(text).includes('>');
        },
        stripHtml(html) {
            let tmp = document.createElement("DIV");
            tmp.innerHTML = html;
            return tmp.textContent || tmp.innerText || "";
        },
        validarPermisoNotificaciones() {
            document.addEventListener('DOMContentLoaded', () => {

                if (!Notification) {
                    return;
                }

                if (Notification.permission !== 'granted') {
                    Notification.requestPermission();
                }
            });
        },
        async accionNotify(notification) {
            if (notification.data.table && notification.data.table == 'temporary_locations') {
                this.setTabActive(13)
            }
            await this.notificationMarkAsRead(notification.id)
            if (notification.data.url) {
                this.notify = false
                if (this.$route.path !== notification.data.url) await this.$router.push(notification.data.url);
            }
        },
        startTimer() {
            this.activityTimer = setInterval(async () => {
                this.inactiveTime += 1000;
                if (this.inactiveTime >= this.activityTimeout) {
                    this.to = moment().format('YYYY-MM-DD HH:mm:ss');
                    if (this.sendInfo === false) {
                        if (this.statusList.includes(this.statusResponse)) {
                            this.setSendUserActiveInSystem(true);
                            await this.saveTimeActiveFromUserAuth({ from: this.from, to: this.to, reactive: false, uuid: getUuidToUser(),user_id: this.acls.usuario_id || null  });
                            this.sendInfo = true;
                        }
                    }
                } else {
                    if (this.sendInfo) {
                        this.from = moment().format('YYYY-MM-DD HH:mm:ss')
                        this.sendInfo = false;
                        this.setSendUserActiveInSystem(false);
                    }
                }
            }, 1000);
        },
        resetTimer() {
            this.inactiveTime = 0;
        },

        /**
           * Agregar o eliminar evento a los Links del menú.
           * @param action
           */
        addRefEventToItemMenu(action = true) {
            const navLinks = document.querySelectorAll('.nav-link:not(.nav-dropdown-toggle), .nav-dropdown-item');

            navLinks.forEach((link) => {
                if (action) {
                    link.addEventListener('click', this.handleSidebarNavItemClick);
                } else {
                    link.removeEventListener('click', this.handleSidebarNavItemClick);
                }
            });
        },

        /**
        * Buscar items.
        *
        * @param param
        */
        filterMenu(param, timeToSearch = 0) {

            /* const results = this.filterByName(this.navItems, param);
            setTimeout(() => this.navItems = this.validMenuWithPermissions(results), timeToSearch) */
            const currentOrTemporaryItems = (this.navItems && this.navItems.length) > 0 ? this.navItems : this.navItemsTemporary
            const results = this.filterByName(currentOrTemporaryItems, param);
            setTimeout(() => {
                this.navItems = this.validMenuWithPermissions(results)
                this.overlayMenu = false
            }, timeToSearch)

        },

        /**
        * Evento buscar ítems del menú.
        */
        onHandleSearch(event) {

            const valueToSearch = event.target.value
            this.filterSearch = valueToSearch
            if (valueToSearch && valueToSearch.length <= 0) return false;

            this.overlayMenu = true

            if ((valueToSearch && valueToSearch.length <= 0) || !valueToSearch) {
                this.menu();
                this.overlayMenu = false
                return
            }

            if (event.key === "Backspace")  this.overlayMenu = false

            else this.filterMenu(valueToSearch, 800)

        },

        /**
        * Evento buscar ítems del menú a partir de un sugerencia.
        *
        * @param itemName
        */
        onHandleSearchWithSuggested(itemName) {

            this.filterSearch = itemName

            this.menu();
            this.filterMenu(itemName)

        },

        /**
        * Evento cancelar buscar ítems del menú.
        */
        onHandleCancelSearch() {

            this.filterSearch = null;
            this.menu();

        },

        /**
        * Filtrar ítems del menú por la propiedad Nombre.
        *
        * @param items
        * @param searchTerm
        */
        filterByName(items, searchTerm, itemDadName = '') {
            const normalizeText = (text) =>
                text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

            const normalizedSearchTerm = normalizeText(searchTerm);

            return items
                .map(item => {

                    const normalizedItemName = normalizeText(`${itemDadName} ${item.name}`);
                    const hasMatchingChildren = item.children
                        ? this.filterByName(item.children, searchTerm, item.name)
                        : [];

                    const isMatch = normalizedItemName.includes(normalizedSearchTerm);

                    if (isMatch || hasMatchingChildren.length > 0) {
                        return {
                            ...item,
                            children: hasMatchingChildren.length > 0 ? hasMatchingChildren : undefined
                        };
                    }

                    return null;
                })
                .filter(Boolean);
        },

        /**
        * Validar los ítems dle menú, control y permisos.
        *
        * @param menuItems
        */
        validMenuWithPermissions(menuItems) {
            this.acls = getAcls();

            const navItems = [];
            const items = menuItems ? menuItems : nav.items;

            items.forEach((item) => {

                let item_menu = JSON.parse(JSON.stringify(item));

                if (item_menu.url && item_menu.url.includes('/my-company')) {
                    let my_company = this.my_company || localStorage.getItem('my_company');
                    item_menu.url = item_menu.url.replace(':id', my_company);
                }

                let visible = this.validarPermiso(item);

                if (item.children) {
                    item_menu.children = [];
                    item.children.forEach((sub_item) => {
                        if (this.validarPermiso(sub_item)) {
                            visible = true
                            item_menu.children.push(sub_item);
                        }
                    });
                }

                if (visible || (!!item_menu.children && !!item_menu.children.length)) navItems.push(item_menu);
            });

            /*   this.overlayMenu = false */

            this.addRefEventToItemMenu();

            return navItems;

        },

        /**
        * Evento Clic a los Ítems del Menú.
        * @param event
        */
        handleSidebarNavItemClick(event) {
            const targetElement = event.currentTarget || event.target;

            if (targetElement.classList && targetElement.classList.contains('nav-dropdown-toggle')) return;

            if (this.$refs.mainContainerRef) this.$refs.mainContainerRef.classList.remove('sidebar-show');

            if (this.isMobileDevice() && this.isSidebarMinimized === false) {
                this.toggleSidebarSmooth();
            }

            setTimeout(() => this.onHandleCancelSearch(), 600);

        },


        async onReactivateUserActiveInSystem() {
            if (this.sendUserActiveInSystem) {
                this.setSendUserActiveInSystem(false);
            await this.saveTimeActiveFromUserAuth({ from: this.from, to: this.to, reactive: true, uuid: getUuidToUser(),user_id: this.acls.usuario_id || null  });
            }
        },

    },

    computed: {
        ...mapState("control_panel", ['fullscreenActive']),
        ...mapState("autenticacion", ['statusResponse']),
        ...mapState('empresa', ['selectedImagenCurrentCompany', 'selectedImagen']),
        ...mapState('auth', ['sendUserActiveInSystem']),
        name() {
            return this.$router.apps[0]._route.meta.title;
        },
        list() {
            return this.$router.apps[0]._route.matched.filter(
                (route) => route.meta.title || route.meta.breadcrumb
            );
        },
        ...mapState('dashboard', ['loading', 'controlAccesos', 'notifications', 'load']),
        ...mapState('autenticacion', ['ingreso', 'my_company']),

        getMenuExample() {
            const items = this.validMenuWithPermissions();
            return typeof items === 'object' ? items.splice(1, 8) : [];
        },

        getUser() {
            let userName = {
                name: "Bienvenido",
                username: "",
                email: '---',
                roles: []
            };

            try {

                if (this.acls && typeof this.acls === 'object' && 'user' in this.acls) {
                    userName = {
                        name: this.acls.user,
                        username: this.acls.user && this.acls.user.split(' ').map(x => x.slice(0, 1).toUpperCase()).join(''),
                        email: localStorage.getItem('email'),
                        roles: this.acls.roles
                    }
                }

                return userName

            } catch (error) {
                return userName
            }
        }

    },

    beforeDestroy() {

        this.addRefEventToItemMenu(false);

        window.removeEventListener("mousemove", this.resetTimer);
        window.removeEventListener("keypress", this.resetTimer);
        window.removeEventListener("click", this.resetTimer);
        window.removeEventListener("scroll", this.resetTimer);
        clearInterval(this.activityTimer);
        this.from = null

        const sidebarEl = document.querySelector('.custom-sidebar');
        if (sidebarEl && this._sidebarClickDelegatedHandler) {
            sidebarEl.removeEventListener('click', this._sidebarClickDelegatedHandler, true);
            this._sidebarClickDelegatedHandler = null;
        }
    },

    updated() {
        const showMenu = this.$route.path === '/panel-de-control' ? false : true;
        if (this.$refs.sidebarToggler) {
            this.$refs.sidebarToggler.toggle(showMenu)
        }
    }

};
</script>

<style>
/* VARIABLES CSS */
:root {
    --sidebar-width: 200px;
}

.ml-roles {
    margin-left: 30pt;
    margin-bottom: 0;
}

.company-content-navbar button {
    background-color: white;
    height: 2.7rem;
    padding: 1pt;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #ffffff;
    cursor: normal;
    border-radius: 6pt;
}

.company-content-navbar button {
    padding: 0pt;
}

.company-content-navbar button img {
    height: 80%;
    object-fit: cover;
    border-radius: 6pt;
}

.user-content-navbar a {
    background-color: transparent;
    width: 2.5rem;
    height: 2.5rem;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 0px solid #20a8d8;;
    border-radius: 50%;
}

.user-content-navbar:hover {
    cursor: pointer;
}

.custom-class-user-content-navbar {
    width: fit-content;
    min-width: 254pt;
    box-shadow: var(--ds-shadow-overlay, 0 4px 8px -2px rgba(9, 30, 66, 0.25), 0 0 1px rgba(9, 30, 66, 0.31));
}

.custom-class-user-content-navbar :first-child {
    right: 0;
}

.custom-class-user-content-navbar--header-img span {
    width: 2.5rem;
}

.custom-class-user-content-navbar-roles {
    display: block !important;
    width: 100%;
    padding: 20pt 0;
    border-bottom: 1px solid #e1e3e1;
    margin: 5pt 0;
}

.custom-class-user-content-navbar-separator {
    border-bottom: 1px solid #e1e3e1;
    width: 100%;
    padding-bottom: 10pt;
}

.custom-class-user-content-navbar-items {
    padding: 8pt;
    width: 100%;
    border-radius: 4pt;
}

.custom-class-user-content-navbar-items:hover {
    cursor: pointer;
    background: #f0f0f0;
}

.custom-class-user-content-navbar a,
.custom-class-user-content-navbar-items a {
    text-decoration: none !important;
}

.language-container {
    cursor: pointer;
}

/* Estilos dropdown */
.dropdown-menu {
    width: fit-content;
    padding: 8px 12px;
    background-color: #fff;
    border-radius: 5px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
}

.dropdown-user-panel p {
    padding: 0;
}
.b-dropdown-text {
    display: inline-block;
    padding: 0 !important;
    margin-bottom: 0;
    width: 100%;
    clear: both;
    font-weight: lighter;
}
.dropdown-item  {
    padding: 10px ;
}

.dropdown-item .badge {
    position: static !important;
    margin-top: 0 !important;
    right: auto !important;
}

.custom-badge-size {
    font-size: 10pt;
}

.notification-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.notification-item i {
    padding-left: 12px;
}

.language-item  {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
}
.language-item-item i {
    padding-left: 14px;
}

.custom-dropdown-font-size {
    font-size: 12.5px !important;
}

.custom-dropdown-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    cursor: pointer;
}

.custom-dropdown-item i {
    font-size: 1rem;
    margin: 0 !important;
}

.custom-dropdown-item b-link {
    font-size: 12.5px;
}

.btn:hover {
    color: #23282c;
    text-decoration: none;
}

a:hover {
    color: #167495;
    text-decoration: none;
}
.user-name {
    color: #818182;
    font-weight: bold;
}

.user-email {
    color: #73818F;
}

.dropdown-menu-espaciado {
    min-width: 348px;
    width: auto;
    left: -68px !important;
    top: -20px !important;
}



.container-fluid {
    padding: 20px !important;
}

.main-content {
    background-color: white !important;
}

.text-version {
    background: #f0f3f5;
    color: #0f0f0f;
    padding: .1em 1em;
    margin-bottom: 0px;
}

.main-content-cp {
    background-color: #e4e5e6 !important;
}

/* Estilos buscador */

.filter-search-container {
    padding: 0.3rem;
    width: 100%;
}

.filter-search-form {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
}

.filter-search-form-input {
    border: 1px solid #e1e3e1;
    border-radius: 5px;
    padding: 7px 2rem;
    width: 100%;
    outline: none;
}

.filter-search-form-icon {
    position: absolute;
    left: 0.40rem;
    top: 0.60rem;
    color: #058580;
    font-size: 1.3rem;
}

.filter-search-form-icon-cancel {
    position: absolute;
    right: 0.40rem;
    top: 0.65rem;
    color: #636565;
    font-size: 1.1rem;
}

.filter-search-form-icon-cancel:hover {
    cursor: pointer;
    opacity: 0.8;
}

.inicio-gradient {
    background: linear-gradient(135deg, #E0E4E6FF, #E0F2F8FF);
    background-size: cover;
}


.inicio-gradient-2 {
    background-color: transparent !important;
}

.custom-navbar-brand {
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
}

@media (min-width: 992px) {
    .custom-navbar-brand {
        justify-content: flex-start !important;
        padding-left: 4px !important;
    }
}

@media (min-width: 516px) and (max-width: 994px) {
    .custom-navbar-brand {
        justify-content: flex-start !important;
        text-align: left !important;
        margin-left: 0 !important;
        padding-left: 0 !important;
        float: left !important;
        position: relative !important;
        left: 0 !important;
    }

    .company-content-navbar img {
        max-height: 28px;
        width: auto;
        object-fit: contain;
        border-radius: 6px;
    }
    .custom-sidebar-toggle {
        margin-right: 4px;
    }
}

@media (max-width: 515px) {
    .company-content-navbar {
        display: none;
    }
}

@media (max-width: 390px) {
    .app-header {
        flex-wrap: nowrap;
    }
    .app-header .navbar-nav.ml-auto {
        flex: 0 0 auto;
        margin-left: auto;
    }
}
</style>

<style scoped>
/*  SIDEBAR TOGGLE BUTTON */
.custom-sidebar-toggle {
    background: transparent;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    margin-left: 8px;
    font-size: 18px;
    cursor: pointer;
    border-radius: 6px;
    transition: all 0.3s ease;
}

.custom-sidebar-toggle:hover {
    color: #495057;
    background-color: rgba(0, 0, 0, 0.08);
    transform: scale(1.05);
}

.custom-sidebar-toggle:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.custom-sidebar-toggle:active {
    transform: scale(0.95);
}

.toggle-icon {
    width: 20px;
    height: 20px;
    filter: brightness(0) saturate(100%) invert(60%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%);
    transition: filter 0.3s ease;
}

.custom-sidebar-toggle:hover .toggle-icon {
    filter: brightness(0) saturate(100%) invert(40%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%);
}

/* SIDEBAR PRINCIPAL */
.custom-sidebar {
    position: fixed;
    top: 0;
    left: 0;
    height: calc(100vh - 50px);
    width: 210px;
    color: white;
    transition: width 0.3s ease, transform 0.3s ease;
    z-index: 1000;
    overflow-y: overlay;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
}

.custom-sidebar.minimized {
    width: 50px;
}

.custom-sidebar.minimized:hover {
    width: 200px;
}

/* Ajustar contenido principal */
.main {
    margin-left: 200px;
    transition: margin-left 0.3s ease;
}

.custom-sidebar.minimized + .main {
    margin-left: 50px;
}

/* BUSCADOR SIDEBAR */
.sidebar-search {
    background: #EDEDED;
    padding: 0.3rem;
    position: sticky;
    top: 0;
    width: 200px;
    display: block;
    z-index: 10;
}

.custom-sidebar.minimized .sidebar-search {
    display: none;
}

.custom-sidebar.minimized:hover .sidebar-search {
    display: none;
}

.search-container {
    position: relative;
}

.search-input {
    width: 100%;
    padding: 8px 24px;
    border: 1px solid rgba(172, 171, 171, 0.384);
    border-radius: 4px;
    color: 0000;
    font-size: 0.9rem;
}

.search-input::placeholder {
    color: #9ca3af;
}

.search-input:focus {
    outline: none;
    border-color: #20a8d8;
}

.search-icon {
    position: absolute;
    left: 0.5rem;
    top: 50%;
    transform: translateY(-50%);
    color: #1A94C0;
}

.search-clear {
    position: absolute;
    right: 0.5rem;
    top: 50%;
    transform: translateY(-50%);
    color: #9ca3af;
    cursor: pointer;
}

.search-clear:hover {
    color: #1A94C0;
}

.button-menu-update {
    background: #EDEDED;
    width: 200px;
}

/* Botón de actualizar menú */
.sidebar-reset {
    padding: 1rem;
    background: #f8f9fa;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    text-align: center;
}

.reset-text {
    color: #6c757d;
    font-size: 0.9rem;
    margin-bottom: 0.5rem;
    margin: 0 0 0.5rem 0;
}

.reset-button {
    background: #20a8d8;
    color: white;
    border: none;
    border-radius: 4px;
    padding: 0.5rem 1rem;
    font-size: 0.9rem;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    width: 100%;
}

.reset-button:hover {
    background: #1A94C0;
}

.reset-button i {
    font-size: 0.8rem;
}

/* NAVEGACIÓN SIDEBAR */
.sidebar-nav {
    flex: 1;
    margin-top: 55px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    height: 100%;
}

.nav-menu {
    list-style: none;
    padding: 0;
    margin: 0;
    width: 200px;
    overflow-y: overlay;
    height: 100%;
    background: #EDEDED;
}

.nav-item {
    margin: 0;
}

.nav-item:last-child {
    border-bottom: none;
}

.nav-link {
    display: flex;
    align-items: center;
    padding: 10px 16px;
    color: white;
    text-decoration: none;
    transition: all 0.3s ease;
    width: 100%;
    background: #1A94C0;
    border: 1px solid #fff;
}

.nav-link:hover {
    background: #20a8d8;
    color: white;
}

/* Estados activos de navegación */
.custom-sidebar .nav-link.router-link-active:not(.nav-dropdown-toggle),
.custom-sidebar .nav-link.router-link-exact-active:not(.nav-dropdown-toggle) {
    background: linear-gradient(90deg, #165c75, #1889b2);
    color: rgb(255, 255, 255);
}

.custom-sidebar .nav-dropdown-toggle.router-link-active,
.custom-sidebar .nav-dropdown-toggle.router-link-exact-active {
    background: transparent;
    color: white;
    border-left-color: transparent;
}

/* Sub-items del sidebar principal en estado activo */
.custom-sidebar .nav-dropdown-item.router-link-active,
.custom-sidebar .nav-dropdown-item.router-link-exact-active {
    background: #EDEDED !important;
    color: white !important;
}

.nav-group {
    cursor: default;
    opacity: 0.8;
    color: white;
}

.nav-group:hover {
    background: rgba(255, 255, 255, 0.05);
    color: white;
}

/* DROPDOWN NAVEGACIÓN */
.nav-dropdown {
    margin: 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

.nav-dropdown:last-child {
    border-bottom: none;
}

.nav-dropdown-toggle {
    cursor: pointer;
    position: relative;
}

.nav-dropdown-toggle:hover {
    background: #20a8d8;
    color: white;
}

.nav-dropdown-toggle:hover .nav-arrow {
    color: white;
    font-weight: bold;
}

.nav-dropdown-toggle:active,
.nav-dropdown-toggle:focus {
    background: transparent;
}

.nav-arrow {
    margin-left: auto;
    transition: transform 0.3s ease;
    font-size: 0.7rem;
    color: #7a7a7a;
    font-family: Arial, sans-serif;
    opacity: 1;
    display: flex;
    align-items: center;
    height: 100%;
}

.nav-arrow.rotated {
    transform: translateY(-50%) rotate(0deg);
}

.nav-dropdown-menu {
    background: #ffffff;
    border-radius: 0 4px 4px 0;
}

.nav-dropdown-item {
    font-size: 0.85rem;
    border: 1px solid rgba(0, 0, 0, 0.1);
    background: #ffffff;
    color: #097B83;
    display: flex;
    align-items: center;
}

.nav-dropdown-item:last-child {
    border-bottom: none;
}

.nav-dropdown-item .nav-text {
    color: #097B83;
}

.nav-dropdown-item .nav-icon {
    color: #097B83;
}

.nav-dropdown-item:hover .nav-text {
    color: #165c75;
}

/* ESTADOS FILTRADOS */

/* Items del menú cuando hay búsqueda activa */
.custom-sidebar:has(.sidebar-search input:not(:placeholder-shown)) .nav-link {
    color: white;
}

.nav-link.filtered {
    background: #1A94C0 !important;
    color: white !important;
    border-left-color: #17a2b8 !important;
}

.nav-link.filtered:hover {
    background: #20a8d8 !important;
    color: white !important;
}

/* Sub-items dentro de items filtrados */
.nav-link.filtered .nav-dropdown-item,
.nav-dropdown-menu .nav-dropdown-item {
    background: #ffffff !important; /** item y subitem fondo filtrados */
    color: #097B83 !important;
    border-bottom: 1px solid #dbdbdb !important;
}

.nav-link.filtered .nav-dropdown-item:hover,
.nav-dropdown-menu .nav-dropdown-item:hover {
    background: #dbdbdb !important;
    color: #165c75 !important;
}

.nav-link.filtered .nav-dropdown-menu {
    background: #ffffff !important;
}

.nav-link.filtered .nav-dropdown-item .nav-text {
    color: #097B83 !important;
}

.nav-link.filtered .nav-dropdown-item:hover .nav-text {
    color: #165c75 !important;
}

.nav-link.filtered .nav-dropdown-item.router-link-active .nav-text {
    color: #EDEDED !important;
}

.nav-link.filtered .nav-dropdown-item .nav-icon {
    color: #097B83 !important;
}

.nav-link.filtered .nav-dropdown-item:hover .nav-icon {
    color: #165c75 !important;
}

.nav-link.filtered .nav-dropdown-item.router-link-active .nav-icon {
    color: #165c75 !important;
}

/* Links filtrados y activos al mismo tiempo */
.nav-link.filtered.router-link-active,
.nav-link.filtered.router-link-exact-active {
    background: linear-gradient(90deg, #165c75, #1889b2) !important;
    color: white !important;
    border-left-color: #17a2b8 !important;
}

/* Hover para links filtrados y activos */
.nav-link.filtered.router-link-active:hover,
.nav-link.filtered.router-link-exact-active:hover {
    background: #20a8d8 !important;
    color: white !important;
}

/* Sub-items filtrados y activos */
.custom-sidebar .nav-dropdown-item.filtered.router-link-active,
.custom-sidebar .nav-dropdown-item.filtered.router-link-exact-active {
    background: #EDEDED !important;  /** item y subitem fondo filtrados active*/
    color: white !important;
}

/* Hover para sub-items filtrados y activos */
.custom-sidebar .nav-dropdown-item.filtered.router-link-active:hover,
.custom-sidebar .nav-dropdown-item.filtered.router-link-exact-active:hover {
    background: #dbdbdb !important;
    color: white !important;
}

.nav-dropdown-item.filtered.router-link-active .nav-text,
.nav-dropdown-item.filtered.router-link-active .nav-icon {
    color: white !important;
}

/* SCROLLBAR */
.nav-menu::-webkit-scrollbar {
    width: 8px;
    background-color: transparent;
}

.nav-menu::-webkit-scrollbar-thumb {
    background-color: transparent;
    border-radius: 4px;
    transition: background-color 0.3s ease;
}

.nav-menu::-webkit-scrollbar-track {
    background-color: transparent;
    transition: background-color 0.3s ease;
}

.nav-menu::-webkit-scrollbar-thumb:hover {
    background-color: rgba(128, 128, 128, 0.4);
}

.nav-menu:hover::-webkit-scrollbar-thumb {
    background-color: rgba(128, 128, 128, 0.4);
}

/* Ocultar scroll cuando el sidebar está colapsado */
.custom-sidebar.minimized,
.custom-sidebar.minimized .sidebar-nav {
    scrollbar-width: none;
}

.custom-sidebar.minimized::-webkit-scrollbar {
    width: 0;
    height: 0;
    background: transparent;
}

.custom-sidebar.minimized:hover::-webkit-scrollbar {
    width: 4px;
    height: 4px;
}

/* UTILIDADES Y FOOTER */
.nav-icon {
    width: 20px;
    height: 20px;
    margin-right: 0.75rem;
    margin-top: 0.3rem;
    text-align: center;
    flex-shrink: 0;
}

.nav-text {
    white-space: wrap;
    overflow: hidden;
    transition: all 0.3s ease;
    color: white;
    flex: 1;
}

.custom-sidebar.minimized .nav-text {
    opacity: 0;
    width: 0;
    overflow: hidden;
    transition: all 0.3s ease;
    display: none;
}

.custom-sidebar.minimized:hover .nav-text {
    opacity: 1;
    width: auto;
    overflow: visible;
    transition: all 0.3s ease;
    display: inline-block;
}

/* Footer */
.sidebar-footer {
    padding: 1rem;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    text-align: center;
}

.version-info {
    color: rgba(255, 255, 255, 0.6);
    font-size: 0.8rem;
}

.custom-sidebar.minimized .version-info {
    display: none;
}

.custom-sidebar.minimized:hover .version-info {
    display: block;
}

/* Dropdown en sidebar colapsado */
.custom-sidebar.minimized .nav-dropdown-menu {
    display: none;
}

.custom-sidebar.minimized:hover .nav-dropdown-menu {
    display: block;
}

.custom-sidebar.minimized .nav-arrow {
    display: none;
}

.custom-sidebar.minimized:hover .nav-arrow {
    display: block;
}

.sidebar-version-placeholder {
    position: sticky;
    bottom: 0px;
    left: 0;
    width: var(--sidebar-width);
    margin: 0;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
}

/* RESPONSIVE (MEDIA QUERIES) */
@media (max-width: 991.98px) {
    .custom-sidebar {
        width: 210px;
        height: 100vh;
        transform: translateX(-100%);
        transition: transform 0.3s ease;
    }

    .custom-sidebar.minimized {
        transform: translateX(-100%);
        width: 210px;
    }

    .custom-sidebar.minimized:hover {
        transform: translateX(-100%);
        width: 210px;
    }

    .custom-sidebar.show-mobile {
        transform: translateX(0);
    }

    /* El contenido principal no se mueve en móvil */
    .main {
        margin-left: 0 !important;
        transition: none;
    }

    /* Overlay para cerrar sidebar en móvil */
    .sidebar-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        z-index: 999;
        opacity: 0;
        visibility: hidden;
        transition: opacity 0.3s ease, visibility 0.3s ease;
    }

    .sidebar-overlay.show {
        opacity: 1;
        visibility: visible;
    }
}

</style>